import React from "react";
import { Link } from "react-router-dom";

import DotGrid from "./DotGrid";

// Image imports
import atomLogo from "../../images/logo/bgAtom.png";
import getItOnLogo from "../../images/logo/getit_on.png";

const Footer: React.FC = () => {
  return (
    <footer className="footer atom-footer">
      <div className="atom-footer-dotgrid" aria-hidden="true">
        <DotGrid />
      </div>
      <div className="atom-footer-inner">
        <div className="atom-footer-brand">
          <Link to="/" className="atom-footer-logo" aria-label="Atom">
            <img src={atomLogo} alt="Atom" />
          </Link>
          <div className="atom-footer-badges">
            <img src={getItOnLogo} alt="Get it on" />
          </div>
          <div className="atom-footer-copy">
            <p>© 2025 ATOM FOUNDATION. Powered by ATOM.</p>
          </div>
        </div>

        <div className="atom-footer-cols">
          <div className="atom-footer-col">
            <h4 className="atom-footer-title">Pages</h4>
            <ul className="atom-footer-links">
              <li>
                <a href="https://whitelist.atomfoundation.io/" target="_blank" rel="noopener noreferrer">Join Whitelist</a>
              </li>
              <li>
                <a href="https://atom-foundation.gitbook.io/atom-foundation-docs" target="_blank" rel="noopener noreferrer">Whitepaper</a>
              </li>
              <li>
                <a href="https://blocksafu.com/audit/0x85c9793Ac3e8328ddEE86590A015717D63C3d348" target="_blank" rel="noopener noreferrer">Audit</a>
              </li>
            </ul>
          </div>

          <div className="atom-footer-col">
            <h4 className="atom-footer-title">Inner Pages</h4>
            <ul className="atom-footer-links">

              <li>
                <a href="https://atom-foundation.gitbook.io/atom-foundation-docs/verify-it-yourself-register-company-illinois" target="_blank" rel="noopener noreferrer">Register Company</a>
              </li>
              <li>
                <a href="https://dex.atomfoundation.io/" target="_blank" rel="noopener noreferrer">Alpha Dex Testnet I</a>
              </li>
              <li>
                <a href="https://dashboard.atomfoundation.io/" target="_blank" rel="noopener noreferrer">Alpha Dashboard Tesnet I</a>
              </li>
            </ul>
          </div>

          <div className="atom-footer-col">
            <h4 className="atom-footer-title">Utility Page</h4>
            <ul className="atom-footer-links">
              <li>
                <a href="https://atom-foundation.gitbook.io/atom-foundation-docs/tokenomics-and-distribution" target="_blank" rel="noopener noreferrer">Tokenomics</a>
              </li>
              <li>
                <a href="https://atom-foundation.gitbook.io/atom-foundation-docs/token-contract-and-infrastructure-atom" target="_blank" rel="noopener noreferrer">Contract</a>
              </li>
              <li>
                <a
                  href="https://t.me/atomzkvm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Telegram
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/atomrwa"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  X (Twitter)
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
